import styled from 'styled-components';
import screen from 'superior-mq';
import { rem } from 'polished';
import { bp } from 'Styles/helpers';
import PropTypes from 'prop-types';

const ProjectName = styled.h4`
  font-size: ${rem(27)};
  font-family: ${props => props.theme.sansFont};
  color: ${props => props.color === 'white' ? '#fff' : props.theme[props.color]};

  ${screen.below(bp.laptop, `
    font-size: ${rem(25)};
  `)}
`;

ProjectName.propTypes = {
  color: PropTypes.oneOf(['white', 'black', 'blue']),
};

ProjectName.defaultProps = {
  color: 'white',
};

export default ProjectName;
